import React from "react";
import AnalyticsCards from "../customComponents/AnalyticCard";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
const AnalyticsHome = () => {
  const translation = useSelector((state) => state.root.translation);
  return (
    <div className="container-fluid text-center py-5">
      <div className="row justify-content-center align-items-center h-100 banner-wrapper">
        {/* Text Section */}
        <div className="col-md-6">
          <div className="hero-banners">
            <h1
              className="mb-4"
              style={{ color: "#202124", fontWeight: "bold" }}
            >
              {translation?.home || "Home"}
            </h1>
            {/* <p className="mb-3" style={{ color: "#5f6368" }}>
              No data received from your website yet.
            </p> */}
            <p className="mb-4" style={{ color: "#5f6368" }}>
              {translation?.dive_into_the_platform ||
                "Dive into the platform’s features, sharpen your analytical abilities, and leverage data for growth."}
            </p>
            <Link
              to="/operations"
              className="btn btn-primary"
              style={{
                backgroundColor: "#1a73e8",
                borderColor: "#1a73e8",
                padding: "10px 20px",
              }}
            >
              {translation?.go_to_reports || "Go to reports"}
            </Link>
          </div>
        </div>
        {/* Image Section */}
        <div className="col-md-6">
          <img
            src={translation?.home_hero_image || "https://pub-uploads.s3.amazonaws.com/uploads/chat/web/qviuXqeqvO_teal_transparent_image.png"}
            alt="Illustration"
            className="img-fluid"
          />
        </div>
      </div>
      <AnalyticsCards />
    </div>
  );
};

export default AnalyticsHome;
